import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegraFreteService } from "../../../services/regra-frete.service";
import { MatDialog, MatSlideToggleChange } from "@angular/material";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ModalComponent } from "src/app/regra-frete/components/modal/modal.component";
import { Router } from "@angular/router";

/* tslint:disable:component-selector */
@Component({
  selector: "[mandae-regra-item]",
  templateUrl: "./item.component.html",
  // styleUrls: ["./item.component.scss"],
})
export class ItemRegraFreteComponent {
  public current: any = [];

  public index = null;

  @Input()
  public set Item(item) {
    this.current = item;
  }

  @Input()
  public set Index(index) {
    this.index = index;
  }

  @Output()
  public regraResponse: any = new EventEmitter();

  constructor(
    public regraService: RegraFreteService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  public async toggleSituation(event: MatSlideToggleChange) {
    const tipo = event.checked ? "ativará" : "desativará";

    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: "450px",
      data: {
        texto: `Isso ${tipo} essa regra. Deseja continuar?`,
        action: {
          cancel: "Não",
          confirm: "Sim, continuar",
        },
      },
    });

    event.source.checked = this.current.ativa;

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const id = this.current.id;
        delete this.current.id;
        const ativo = event.checked;
        this.current.ativa = ativo;
        event.source.checked = ativo;

        this.alterarRegra(id);
      }
    });
  }

  public async alterarRegra(idAntigo) {
    try {
      const id = idAntigo;
      const novoId = await this.regraService.criarRegra(this.current);
      this.regraResponse.emit({
        tipo: "nova-regra",
        novoId: novoId.id,
        id: idAntigo,
      });
    } catch (error) {}
  }

  public async excluirRegra() {
    try {
      this.regraResponse.emit({
        tipo: "excluir-regra",
        id: this.current.id,
      });
    } catch (error) {}
  }

  public handleDeletar() {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: "450px",
      data: {
        texto: `Você vai excluir essa regra. Deseja continuar?`,
        action: {
          cancel: "Não",
          confirm: "Sim, excluir",
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.excluirRegra();
      }
    });
  }

  public handleEditar() {
    sessionStorage.removeItem("mandae-regra-item");
    sessionStorage.setItem("mandae-regra-item", JSON.stringify(this.current));
    this.router.navigate([
      "/configuracoes-do-usuario/regra-frete/editar/" + this.current.id,
    ]);
  }
}
